export default {
  steps: {
    discount: 'Reducere',
    mobile_app: 'Aplicație mobilă',
    business_info: 'Informații afacere',
    create_preview: 'Creați contract de previzualizare',
    preview: 'Previzualizați contractul',
    sign: 'Semnați contractul',
  },
  buttons: {
    back: 'Înapoi',
    continue: 'Continuați',
  },
  agreement:
    'Trecerea la anual aplică reducerea de {{discount}}% planului tău {{plan}}. Facturarea continuă lunar la {{amount}} pe lună în cadrul unui angajament de {{months}} luni.',
  toasts: {
    failed_to_save_changes: 'Eroare la salvarea modificărilor',
    failed_to_switch: 'Eroare la trecerea la anual',
    switched_to_annual: 'Contractul a fost trecut la anual 👌',
  },
};
